__webpack_require__.p = "/jfl-discovery-ui/public/dist/";